import { actionTypes } from './actions';

const simpleInitialState = {
  isLoading: false,
  hasError: false,
};

const draftInitialState = {
  isSaved: false,
  isRedirectNeeded: false,
  ...simpleInitialState,
};

const yearsInitialState = {
  years: [],
  ...simpleInitialState,
};

const ndfl3XMLDraftReducer = (state = draftInitialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_DRAFT:
      return { ...draftInitialState, ...{ isLoading: true } };

    case actionTypes.SAVE_DRAFT_SUCCESS:
      return {
        ...draftInitialState,
        ...{ isSaved: true, isRedirectNeeded: action.payload.isRedirectNeeded },
      };

    case actionTypes.SAVE_DRAFT_FAILURE:
      return { ...draftInitialState, ...{ hasError: true, error: action.payload } };

    case actionTypes.GET_DRAFT:
      return { ...draftInitialState, ...{ isLoading: true } };

    case actionTypes.GET_DRAFT_SUCCESS:
      return { ...draftInitialState, ...{ draft: action.payload } };

    case actionTypes.GET_DRAFT_FAILURE: {
      return { ...draftInitialState, ...{ hasError: true, error: action.payload } };
    }

    case actionTypes.RESET_DRAFT: {
      return { ...draftInitialState };
    }

    default:
      return state;
  }
};

const ndfl3XMLYearsReducer = (state = yearsInitialState, action) => {
  switch (action.type) {
    case actionTypes.GET_YEARS:
      return { ...yearsInitialState, ...{ isLoading: true } };

    case actionTypes.GET_YEARS_SUCCESS:
      return { ...yearsInitialState, ...{ years: action.payload } };

    case actionTypes.GET_YEARS_FAILURE:
      return { ...yearsInitialState, ...{ hasError: true, error: action.payload } };

    default:
      return state;
  }
};

const ndfl3XMLValidationReducer = (state = simpleInitialState, action) => {
  switch (action.type) {
    case actionTypes.VALIDATE_XML:
      return { ...simpleInitialState, ...{ isLoading: true } };

    case actionTypes.VALIDATE_SUCCESS:
      return { ...simpleInitialState, ...{ data: action.payload } };

    case actionTypes.VALIDATE_FAILURE:
      return { ...simpleInitialState, ...{ hasError: true, error: action.payload } };

    default:
      return state;
  }
};

const ndfl3XMLSubmitDeclarationReducer = (state = simpleInitialState, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_DECLARATION:
      return { ...simpleInitialState, ...{ isLoading: true } };

    case actionTypes.SUBMIT_DECLARATION_SUCCESS:
      return { ...simpleInitialState, ...{ result: action.payload } };

    case actionTypes.SUBMIT_DECLARATION_FAILURE:
      return { ...simpleInitialState, ...{ hasError: true, error: action.payload } };

    default:
      return state;
  }
};

export {
  ndfl3XMLDraftReducer,
  ndfl3XMLYearsReducer,
  ndfl3XMLValidationReducer,
  ndfl3XMLSubmitDeclarationReducer,
};
